<mat-card class="createCard">
    <mat-card-title class="text-center">
        <h1 class="text-black registerTitle">Join {{ companyName }}'s Community</h1>
    </mat-card-title>
    <mat-card-content>
        <app-register [community]="community" [invite]="inviteResponse"></app-register>
    </mat-card-content>
</mat-card>
